<div style="padding:30px">
    <div class="card text-white bg-light mb-3 info_item" style="margin-top:10px">
        <!-- <div class="card-header">   
          注意
         </div> -->

        <div class="card-body" *ngIf="top_info.time">
            <div class="card-text top_info_num">最新紀錄時間：<span class="show_it">{{top_info.time}}</span></div>
            <div class="card-text top_info_num tips"><span class="show_it">每15分鐘更新一次</span></div>
        </div>
    </div>

    <input type="text" placeholder="輸入查詢號碼" (keyup.enter)="pageobj.page=0;init_list()"  class="form-control" style="width:160px;display: inline"  [(ngModel)]="search_model">
    <button class="btn btn-primary" (click)="pageobj.page=0;init_list()">搜尋</button>

    <app-table-v2  [type]="1" [tcontent]="tcontent" [data]="data" *ngIf="data.length>0">
        <ng-template let-post #operation_dk>
            <div *ngIf="post.key == 'calltime'">
                {{post.val.t5}}
                <span *ngIf="post.val.t5!='-' && post.val.t5!='無資料'">秒</span>
            </div>
            <div *ngIf="post.key == 'twocall'">
                <span *ngIf="post.val.cname!='-'">{{post.val.cname}}</span>
                <span *ngIf="post.val.cname=='-'" class="tips">不需二次驗證</span>
            </div>
        </ng-template>
    </app-table-v2>

    <app-pagnation (callback)="callback($event)" [data]="pageobjstr"></app-pagnation> 
    <div *ngIf="data.length==0">無資料</div>    
  </div>
  <app-spinner [loading]="loading"></app-spinner>